/* Shared support entry points. Opening the Messenger never sends a message. */
(() => {
  if (window.PCSiteInteractions) return;
  window.PCSiteInteractions = true;
  let timer, pending, attempt = 0;
  function feedback(button, message) {
    let note = button.parentElement.querySelector('[data-pc-chat-status]');
    if (!note) {
      note = document.createElement('span');
      note.className = 'pc-chat-status'; note.dataset.pcChatStatus = '';
      note.setAttribute('role', 'status'); button.after(note);
    }
    note.textContent = message;
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-pc-chat]');
    if (!button) return;
    event.preventDefault();
    clearTimeout(timer);
    pending?.removeAttribute('aria-busy');
    pending?.parentElement?.querySelector('[data-pc-chat-status]')?.remove();
    pending = button; attempt = 0;
    document.dispatchEvent(new CustomEvent('pc:chatopen'));
    function open() {
      if (typeof window.Intercom === 'function') {
        button.removeAttribute('aria-busy');
        button.parentElement.querySelector('[data-pc-chat-status]')?.remove();
        window.Intercom('show');
        return;
      }
      if (attempt++ < 20) {
        button.setAttribute('aria-busy', 'true');
        if (attempt === 1) feedback(button, 'Opening support chat…');
        timer = setTimeout(open, 250);
      } else {
        button.removeAttribute('aria-busy');
        feedback(button, 'Chat couldn’t load. Please refresh the page and try again.');
      }
    }
    open();
  });
})();
